import { ReactComponent as ArrowRight } from "assets/icons/arrow-right-with-line.svg";

const NextStepButton = ({ onNext }) => {
  return (
    <div
      className="fixed flex bottom-[20px]  w-[45px] h-[45px]  z-40 cursor-pointer border rounded bg-[#1F1F1F] rotate-45"
      onClick={onNext}
    >
      <ArrowRight className="w-5 h-5 m-auto  rotate-[-45deg] [&>path]:fill-white" />
    </div>
  );
};

export default NextStepButton;
